import { Controller, useFormContext } from 'react-hook-form';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

// ----------------------------------------------------------------------

export function RHFAutocomplete({
  name,
  label,
  inputType = 'text',
  helperText,
  hiddenLabel,
  placeholder,
  allowCustomValue = false,
  handleOnChange = null,
  ...other
}) {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          id={`rhf-autocomplete-${name}`}
          freeSolo={allowCustomValue}
          onChange={(event, newValue) => {
            setValue(name, newValue?.value?.toString() ?? '', { shouldValidate: true });
            handleOnChange && handleOnChange(newValue?.value?.toString());
          }}
          onInputChange={(event, newInputValue) => {
            if (allowCustomValue) {
              setValue(name, newInputValue ?? '', { shouldValidate: true });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              type={inputType}
              placeholder={placeholder}
              error={!!error}
              helperText={error ? error?.message : helperText}
              hiddenLabel={hiddenLabel}
              sx={{ minWidth: 200 }}
              slotProps={{
                htmlInput: {
                  ...params.inputProps,
                  autoComplete: 'off',
                }
              }}
            />
          )}
          {...other}
        />
      )}
    />
  );
}
